import { render } from "./TransportContainerCreateEditDialog.vue?vue&type=template&id=047bae8b&scoped=true&ts=true"
import script from "./TransportContainerCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./TransportContainerCreateEditDialog.vue?vue&type=script&lang=ts"

import "./TransportContainerCreateEditDialog.vue?vue&type=style&index=0&id=047bae8b&scoped=true&lang=css"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047bae8b"]])

export default __exports__